import React from 'react'
import './header.css'

function Header() {
  return (
    <div>
      <div className='first-bg text-center'>
        <h3 className='top'>Food app</h3>
        <h2 className='high'>Why stay hungry when <br /> you can order form Bella Onojie</h2>
        <h4 className='chi'>Download the bella onoje’s food app now on</h4>
        <form class="form-inline cort">
            <button class="btn-2 btn-outline- my-2 my-sm-3" type="submit">Playstore</button>
            <button class="btn-1 btn-outline- my-2 my-sm-0" type="submit">App store</button>
          </form>
      </div>
    </div>
  )
}

export default Header
